import UI from './utils/UI'

UI({
  component: '.js-printButton'
}, ({ component }) => {

  component.addEventListener('click', evt => {
    evt.preventDefault()
    window.print()
  })
})
